module.exports = __webpack_public_path__ + "static/media/user1.b9f72668.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svod/user1.png
// module id = 248
// module chunks = 0